








import {Vue, Component, Prop, Watch, Emit} from "vue-property-decorator";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component
export default class ImagePickerEditor extends mixins(ComponentBaseMixin) {
    @Prop() value!: string;
    previewImage = null;

    created() {
        this.previewImage = this.value;
    }

    @Watch('value')
    onValueChanged(value: string) {
        this.previewImage = value;
    }

    pickFile(evt) {

        let files = evt.target.files;
        if (files.length) {
            let file = files[0];
            if (!file.type.match('image.*')) {
                this.showInfo('morateIzabratiSliku');
                return;
            }
            let reader = new FileReader();
            reader.onload = e => {
                this.previewImage = e.target.result;
                this.input(this.previewImage);
            }
            reader.readAsDataURL(file);
        }
    }

    @Emit() input(value: string) {
    }
}
